import {
  Grid, Stack, Link
} from "@mui/material"

import MKTypography from "components/MKTypography"
import MKBox from "components/MKBox"

export default function Footer() {
  const year = new Date().getFullYear();
  const light = false;

  return (
    <MKBox component="footer" py={6}>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={8} sx={{ textAlign: "center" }}>
          <MKTypography variant="body2" color={light ? "white" : "secondary"}>
            Copyright &copy; {year} by{" "}
            <MKTypography
              component={Link}
              href={"/index"}
              target="_blank"
              rel="noreferrer"
              variant="body2"
              color={light ? "white" : "secondary"}
            >
              {" Jackson Cagle"}
            </MKTypography>
            .
            Website Design Template by{" "}
            <MKTypography
              component={Link}
              href={"https://www.creative-tim.com/"}
              target="_blank"
              rel="noreferrer"
              variant="body2"
              color={light ? "white" : "secondary"}
            >
              {" Creative Tim"}
            </MKTypography>
            .
          </MKTypography>
        </Grid>
      </Grid>
    </MKBox>
  )
}